import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {ProviderModel} from '../../../../models/ProviderModel';
import {RegionModel} from '../../../../models/RegionModel';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {ChargingMethodologyModel} from '../../../../models/ChargingMethodologyModel';
import {TransformationService} from '../service-transformation/transformation.service';
import {TransformationModel} from '../../../../models/TransformationModel';
import * as toastr from 'toastr';
import {ServiceVariantModel} from '../../../../models/ServiceVariantModel';

@Component({
  selector: 'app-edit-transformation',
  templateUrl: './edit-transformation.component.html',
  styleUrls: ['./edit-transformation.component.scss']
})
export class EditTransformationComponent extends BaseGeneralComponent implements OnInit, OnDestroy {
  showActions: boolean;

  transformation: TransformationModel;
  providerSelect: ProviderModel;
  regionSelect: RegionModel;
  localCustomerSelect: LocalCustomerModel;
  contractTypeSelect: ContractTypeModel;
  serviceVariantSelect: ServiceVariantModel;
  currencySelect: CurrencyModel;
  chargingMethodologySelect: ChargingMethodologyModel;
  milestoneNumberSelect: number;
  amountSelect: number;
  perInstallmentSelect: number;
  totalCostSelect: number;
  region1Select: RegionModel;
  perCostRegion1Select: number;
  region2Select: RegionModel;
  perCostRegion2Select: number;

  selected: string;
  saveTransformation: Subscription;
  parameterSubscribe: Subscription;

  registerForm: FormGroup;
  submitted = false;
  transformationJson: any;

  getPageSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private transformationService: TransformationService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService) {
    super();


    this.transformation = new TransformationModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();
    this.providerSelect = new ProviderModel();
    this.contractTypeSelect = new ContractTypeModel();
    this.serviceVariantSelect = new ServiceVariantModel();
    this.currencySelect = new CurrencyModel();
    this.chargingMethodologySelect = new ChargingMethodologyModel();
    this.region1Select = new RegionModel();
    this.region2Select = new RegionModel();
  }

  ngOnInit() {
    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.transformationJson = params['row'];
        this.transformation = JSON.parse(this.transformationJson) as TransformationModel;
        this.localCustomerSelect = this.transformation.localCustomer;
        this.regionSelect = this.transformation.region;
        this.providerSelect = this.transformation.provider;
        this.contractTypeSelect = this.transformation.contractType;
        this.serviceVariantSelect = this.transformation.serviceVariant;
        this.currencySelect = this.transformation.currency;
        this.chargingMethodologySelect = this.transformation.chargingMethodology;
        this.region1Select = this.transformation.region1;
        this.region2Select = this.transformation.region2;
        this.milestoneNumberSelect = this.transformation.milestoneNumber;
        this.amountSelect = this.transformation.amount;
        this.totalCostSelect = this.transformation.totalCost;
        this.perInstallmentSelect = this.transformation.perInstallment;
        this.perCostRegion1Select = this.transformation.perCostRegion1;
        this.perCostRegion2Select = this.transformation.perCostRegion2;
      });


    this.registerForm = this.formBuilder.group({
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      region: [{value: '', disabled: false}, Validators.required],
      provider: [{value: '', disabled: false}, Validators.required],
      contractType: [{value: '', disabled: false}, Validators.required],
      serviceVariant: [{value: '', disabled: false}, Validators.required],
      currency: [{value: '', disabled: false}, Validators.required],
      resourceUnit: [{value: '', disabled: false}, Validators.required],
      chargingMethodology: [{value: '', disabled: false}, Validators.required],
      region1: [{value: '', disabled: false}],
      region2: [{value: '', disabled: false}],
      milestoneNumber: [{value: '', disabled: false}, Validators.required],
      amount: [{value: '', disabled: false}, Validators.required],
      totalCost: [{value: '', disabled: false}, Validators.required],
      perInstallment: [{value: '', disabled: false}, Validators.required],
      perCostRegion1: [{value: '', disabled: false}, Validators.required],
      perCostRegion2: [{value: '', disabled: false}, Validators.required]
    });

    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });

    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });

    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });

    this.registerForm.patchValue({
      contractType: this.contractTypeSelect.cod
    });

    this.registerForm.patchValue({
      serviceVariant: this.serviceVariantSelect.cod
    });

    this.registerForm.patchValue({
      currency: this.currencySelect.cod
    });

    this.registerForm.patchValue({
      resourceUnit: this.serviceVariantSelect.cod
    });

    this.registerForm.patchValue({
      chargingMethodology: this.chargingMethodologySelect
    });

    this.registerForm.patchValue({
      milestoneNumber: this.milestoneNumberSelect
    });

    this.registerForm.patchValue({
      region1: this.region1Select ? this.region1Select.cod : null
    });

    this.registerForm.patchValue({
      region2: this.region2Select ? this.region2Select.cod : null
    });

    this.registerForm.patchValue({
      totalCost: this.totalCostSelect
    });

    this.registerForm.patchValue({
      amount: this.amountSelect
    });

    this.registerForm.patchValue({
      perInstallment: this.perInstallmentSelect
    });

    this.registerForm.patchValue({
      perCostRegion1: this.perCostRegion1Select
    });

    this.registerForm.patchValue({
      perCostRegion2: this.perCostRegion2Select
    });

  }
  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 3}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.loaderService.display(true);
      this.transformation.milestoneNumber = this.registerForm.value.milestoneNumber;
      this.transformation.amount = this.registerForm.value.amount;
      this.transformation.perInstallment = this.registerForm.value.perInstallment;
      this.transformation.totalCost = this.registerForm.value.totalCost;
      this.transformation.perCostRegion1 = this.registerForm.value.perCostRegion1;
      this.transformation.perCostRegion2 = this.registerForm.value.perCostRegion2;

      this.saveTransformation = this.transformationService.update(this.transformationService.baseUrl, this.transformation)
        .subscribe(
          (result: any) => {
            toastr.success('Transformation element was edited with success', 'Success');
            this.loaderService.display(false);
            this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 3}});
          },
          error => {
            toastr.error('Transformation element was not edited', 'Error');
            this.loaderService.display(false);
          });
    }
  }

  ngOnDestroy(): void {
    if (this.saveTransformation) {
      this.saveTransformation.unsubscribe();
    }
    if (this.parameterSubscribe) {
      this.parameterSubscribe.unsubscribe();
    }
  }
  /*
    getElementSelectedLC($event) {
      this.reimbursment.localCustomer = $event.row;
      this.localCustomerSelect = $event.row;
      this.registerForm.patchValue({
        localCustomerCod: this.localCustomerSelect.cod
      });
    }

    getElementSelectedRegion($event) {
      this.reimbursment.region = $event.row;
      this.regionSelect = $event.row;
      this.registerForm.patchValue({
        region: this.regionSelect.cod
      });
    }

    getElementSelectedProvider($event) {
      this.reimbursment.provider = $event.row;
      this.providerSelect = $event.row;
      this.registerForm.patchValue({
        provider: this.providerSelect.cod
      });
    }

    getElementSelectedContractType($event) {
      this.reimbursment.contractType = $event.row;
      this.contractTypeSelect = $event.row;
      this.registerForm.patchValue({
        contractType: this.contractTypeSelect.cod
      });
    }
      getElementSelectedResourceUnit($event) {
      this.reimbursment.resourceUnit = $event.row;
      this.serviceVariantSelect = $event.row;
      this.registerForm.patchValue({
        resourceUnit: this.serviceVariantSelect.cod
      });
    }

    getElementSelectedCurrency($event) {
      this.reimbursment.currency = $event.row;
      this.currencySelect = $event.row;
      this.registerForm.patchValue({
        currency: this.currencySelect.cod
      });
    }
  */


  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }


}
